export default __webpack_public_path__ + "static/hammers-a43c9f81e3716dc8596088ade72f0828.png";